import React, { useEffect, useState } from "react";
import AddImage from "../../../../assets/icons/add-image.svg";
import { EditOutlined } from "@mui/icons-material";
import "../../../../assets/styles/variables.scss";
import ImageUpload from "../upload-image";
import LearnMoreButton from "./LearnMore";

interface WhatWeOfferProps {
  isForSharing: boolean;
  updateTitle?: any;
  title?: string;
  setHideMyTest?: any;
  whatWeOfferData?: any;
  setWhatWeOfferData?: any;
  sectionVisibility?: any;
  setSectionVisibility?: any;
  primaryColor?: string;
  accentColor?: string;
  setImageFiles?: any;
  canWrite?: boolean;
  canDelete?: boolean;
}

const WhatWeOffer: React.FC<WhatWeOfferProps> = ({
  isForSharing,
  whatWeOfferData,
  setWhatWeOfferData,
  setSectionVisibility,
  sectionVisibility,
  primaryColor,
  accentColor,
  setImageFiles,
  canWrite = false,
  canDelete = false,
}) => {
  const [editHeading, setEditHeading] = useState(false);
  const [editBody, setEditBody] = useState(false);

  const handleImageChange = (file: any) => {
    setImageFiles((prev: any) => ({
      ...prev,
      "what-we-offer": file,
    }));
    setWhatWeOfferData((prev: any) => ({
      ...prev,
      imageUrl: file ? URL.createObjectURL(file) : "",
    }));
  };

  const handleImageRemove = () => {
    setWhatWeOfferData((prev: any) => ({
      ...prev,
      imageUrl: "",
    }));
    setImageFiles((prev: any) => {
      const { ["what-we-offer"]: _, ...rest } = prev;
      return rest;
    });
  };

  const textColor = isForSharing ? "#fff" : "#fff";

  return (
    <div>
      <div
        id="what-we-offer-wrapper"
        style={{
          padding: "20px 60px",
          backgroundColor: primaryColor,
          background: primaryColor,
          color: textColor,
          position: "relative",
        }}
      >
        {!isForSharing && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className={
              sectionVisibility?.["partner-success-metrics"] && !isForSharing
                ? "section-header"
                : ""
            }
          >
            {sectionVisibility["what-we-offer"] && (
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 500,
                  border: "none",
                  background: "transparent",
                  margin: 0,
                  wordBreak: "break-word",
                }}
              >
                {whatWeOfferData?.title || "What We Offer"}
              </h3>
            )}
            <button
              onClick={() => {
                if (setSectionVisibility) {
                  setSectionVisibility((prev: any) => ({
                    ...prev,
                    "what-we-offer": !prev["what-we-offer"],
                  }));
                }
              }}
              className={
                sectionVisibility?.["partner-success-metrics"]
                  ? "toggle-section-button"
                  : ""
              }
              style={{
                position: "absolute",
                top: 20,
                right: 20,
                backgroundColor: "#fff",
                color: canWrite ? "#000000" : "rgba(0, 0, 0, 0.3)",
                boxShadow: "0 0 8px rgba(0,0,0,0.3)",
                padding: "6px 24px",
                border: "none",
                cursor: canWrite ? "pointer" : "not-allowed",
                width: "147px",
                height: "42px",
                borderRadius: "8px",
                fontSize: "15px",
              }}
              disabled={!canWrite}
            >
              {sectionVisibility?.["what-we-offer"]
                ? "Show Section"
                : "Hide Section"}
            </button>
          </div>
        )}

        {!sectionVisibility?.["what-we-offer"] && (
          <div
            id="what-we-offer-body-wrapper"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
              gap: "40px",
              height: !isForSharing ? "500px" : "auto",
              alignItems: "center",
            }}
          >
            {!isForSharing || whatWeOfferData?.imageUrl ? (
              <div
                style={{ width: "50%" }}
                className="what-we-offer-body-wrapper-image-upload"
              >
                <ImageUpload
                  imageUrl={whatWeOfferData?.imageUrl || ""}
                  onImageChange={handleImageChange}
                  onImageRemove={handleImageRemove}
                  isForSharing={isForSharing}
                  placeholderImage={AddImage}
                  sectionName="what-we-offer"
                  canWrite={canWrite}
                  canDelete={canDelete}
                />
              </div>
            ) : (
              <div style={{ width: "50%" }}></div>
            )}
            <div
              style={{ display: "flex", width: "40%", flexDirection: "column" }}
              className="what-we-offer-body-wrapper-text-upload"
            >
              {editHeading && !isForSharing ? (
                <input
                  type="text"
                  value={whatWeOfferData?.title || ""}
                  onChange={(e) => {
                    setWhatWeOfferData((prev: any) => ({
                      ...prev,
                      title: e.target.value,
                    }));
                  }}
                  onBlur={() => setEditHeading(false)}
                  autoFocus
                  style={{
                    fontSize: "30px",
                    color: textColor,
                    backgroundColor: "transparent",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    fontWeight: "700",
                    outline: "none",
                    fontFamily: "Roboto, sans-serif",
                  }}
                  maxLength={40}
                />
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <h3
                    style={{
                      fontSize: "30px",
                      margin: 0,
                      fontWeight: "500",
                      letterSpacing: "-0.02rem",
                      width: "auto",
                      maxWidth: "500px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      cursor: "default",
                    }}
                    title={whatWeOfferData?.title}
                  >
                    {whatWeOfferData?.title}
                  </h3>
                  {!isForSharing && (
                    <button
                      onClick={() => setEditHeading(true)}
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        cursor: canWrite ? "pointer" : "not-allowed",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "50%",
                        padding: "4px",
                        width: "32px",
                        height: "32px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                      disabled={!canWrite}
                    >
                      <EditOutlined />
                    </button>
                  )}
                </div>
              )}
              {editBody && !isForSharing ? (
                <textarea
                  id="what-we-offer-body-text"
                  value={whatWeOfferData?.bodyText}
                  onChange={(e) => {
                    setWhatWeOfferData((prev: any) => ({
                      ...prev,
                      bodyText: e.target.value,
                    }));
                  }}
                  onBlur={() => setEditBody(false)}
                  style={{
                    fontSize: "16px",
                    color: textColor,
                    backgroundColor: "transparent",
                    border: "1px solid #BDBDBD",
                    borderRadius: "4px",
                    textAlign: "left",
                    height: "200px",
                    marginTop: "30px",
                    padding: "10px",
                    resize: "none",
                    outline: "none",
                    cursor: canWrite || isForSharing ? "text" : "not-allowed",
                  }}
                  disabled={isForSharing || !canWrite}
                  maxLength={300}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 8,
                  }}
                >
                  <p
                    style={{
                      letterSpacing: "-0.02rem",
                      width: "auto",
                      maxWidth: "750px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      cursor: "default",
                      fontSize: "18px",
                      lineHeight: "30px",
                      marginTop: "1.2rem",
                    }}
                  >
                    {whatWeOfferData?.bodyText || "Body Text..."}
                  </p>
                  {!isForSharing && (
                    <button
                      onClick={() => setEditBody(true)}
                      style={{
                        background: "#fff",
                        border: "1px solid #ccc",
                        cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "50%",
                        padding: "4px",
                      }}
                      disabled={!canWrite}
                    >
                      <EditOutlined fontSize="small" />
                    </button>
                  )}
                </div>
              )}
              <div
                className="learn-more-button-wrapper"
                style={{
                  justifyContent: "flex-start",
                  marginTop: "1rem",
                  display: "flex",
                }}
              >
                {!(isForSharing && !whatWeOfferData?.btnUrl?.trim()) && (
                  <LearnMoreButton
                    isForSharing={isForSharing}
                    primaryColor={accentColor}
                    link={whatWeOfferData?.btnUrl}
                    setLink={setWhatWeOfferData}
                    canWrite={canWrite}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatWeOffer;
